import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../NavBar/Index';
import Sidebar from '../Sidebar/Index';

const Layout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // Open sidebar by default only on desktop screens (>= 768px)
    const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);

    useEffect(() => {
        if (!localStorage.getItem("bentoAdmin")) {
            navigate("/login");
        }
    }, [navigate, location.pathname]);

    return (
        <div className='flex h-screen w-full bg-gray-50 overflow-hidden relative'>
            {/* Mobile Sidebar Overlay */}
            {isSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[90] md:hidden"
                    onClick={() => setIsSidebarOpen(false)}
                />
            )}
            
            <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
            
            <div className='flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden'>
                <Navbar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
                <main className='flex-1 flex flex-col min-h-0 overflow-y-auto overflow-x-hidden'>
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default Layout;
